<template>
    <a-list-item-meta>
        <a-avatar v-if="!app.mobile" slot="avatar" :src="reply.author.avatar" shape="square" class="reply-avatar"/>
        <div slot="description" class="reply-main">
            <p class="reply-text">
                <span>
                    <user-link :name="reply.author.name" :id="reply.author.id"/>:
                    {{ lines[0] }}
                </span>
                <span v-for="line of lines.slice(1)" :key="line">
                    {{ line }}
                </span>
            </p>
            <p class="reply-bottom">
                {{ formatDate(reply.posttime) }}
                <a-button type="link" @click="replyThis()">回复</a-button>
                <a-button v-if="isSelf" type="link" @click="deleteSubpost()">删除</a-button>
                <a-button class="admin-button" v-if="hasEditPrivilege && !isSelf" type="link" @click="deleteSubpostByAdmin()">删除</a-button>
                <a-button class="admin-button" v-if="hasEditPrivilege && !isSelf" type="link" @click="blockUser(reply.author)">封禁</a-button>
            </p>
        </div>
    </a-list-item-meta>
</template>

<script>
import axios from 'axios';
import { createFormData, formatTime } from '../../utils/utils';
import { blockUser } from '../../utils/mixin';
import { checkPrivilege } from '../admin/privilege';
import { mapState } from 'vuex';
import UserLink from '@/components/UserLink.vue';

export default {
    props: {
        reply: Object,
    },
    inject: [ 'app' ],
    computed: {
        ...mapState({ userid: 'userid', userPrivilege: 'privilege' }),
        mobile() {
            return this._mobile;
        },
        hasEditPrivilege() {
            return checkPrivilege({ bbs: 1 }, this.userPrivilege);
        },
        lines() {
            return this.reply.content.split('\n', 3);
        },
        isSelf() {
            return this.userid == this.reply.author.id;
        },
    },
    methods: {
        formatDate(timestamp) {
            return formatTime(timestamp, { day: 'HH:mm' });
        },
        replyThis() {
            this.$emit('reply', this.reply);
        },
        deleteSubpost() {
            const { id: sid } = this.reply;
            this.$confirm({
                title: '确认要删除回复吗？',
                content: h => <div style="color:red;">一旦删除后无法恢复</div>,
                onOk: async() => {
                    const { data } = await axios
                        .post("/backend/bbs/deleteSubpost.php", createFormData({
                            sid
                        }));
                    if (data.code == 0) {
                        this.$message.success('删除成功');
                        window.location.reload();
                    } else {
                        this.$message.error('删除失败');
                    }
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        async deleteSubpostByAdmin() {
            const { id: sid } = this.reply;
            const reason = prompt('确认要删除帖子吗？\n你正在动用管理权限，请给出删除理由', '');
            if (reason !== null) {
                const { data } = await axios
                    .post("/backend/bbs/deleteSubpost.php", createFormData({
                        sid, reason
                    }));
                if (data.code == 0) {
                    this.$message.success('删除成功');
                    window.location.reload();
                } else {
                    this.$message.error('删除失败');
                }
            }
        },
        blockUser,
    },
    components: {
        UserLink,
    }
}
</script>

<style lang="less" scope>
.reply-avatar {
    margin-top: 4px;
    @media screen and (max-width: 599px) {
        display: none;
    }
}
.reply-main {
    text-align: left;
    .reply-text {
        color: #666;
        margin: 0;
        span {
            word-break: break-all;
            display: block;
        }
    }
    .reply-bottom {
        text-align: right;
        margin: 0;
    }
    .ant-btn {
        span {
            margin: 0px;
        }
        padding: 0 6px;
    }
    .admin-button {
        color: grey;
    }
}
</style>